import { Box, TableBody, TableCell, TableHead, TableRow, Table, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ApiImportExportAllocationPoints } from '../../../apiService/Core/Apicall.tsx';
import { useNavigate } from 'react-router-dom';

const AdminDashboard: React.FC = () => {
  const [allocationPoints, setallocationPoints] = useState<any>([]);
  const [currentDate, setCurrentDate] = useState(new Date())
  const navigate = useNavigate()


  const ponitsdata = async () => {
    try {
      const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
      const res = await ApiImportExportAllocationPoints(data)
      setallocationPoints(res.data)

    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {
    ponitsdata()
  }, [])

  return (

    <Box className='d-flex flex-column align-items-center px-3' height='fit-content' pt='20px'>
      <Box width='fit-content' bgcolor='white' className='text-center mb-3 w-75' borderRadius='10px' boxShadow='0px 0px 10px black' padding='40px 20px'>
        <h3> Quick Links</h3>
        <hr />
        <Box className='d-flex justify-content-center' gap={3}>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { navigate('/admin/manage-reports') }}
            className="action-button  action-button--approve table-row-background">
            Manage Report
          </Button>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { navigate('/admin/venue-managers') }}
            className="action-button  action-button--approve table-row-background">
            Manage Venues
          </Button>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { navigate('/admin/shoppers/shoppers-list') }}
            className="action-button  action-button--approve table-row-background">
            Active Shoppers
          </Button>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { navigate('/admin/allocations/monthly-calendar') }}
            className="action-button  action-button--approve table-row-background">
            Monthly Calendar
          </Button>
        </Box>
      </Box>
      <Box bgcolor='white'  className='text-center w-100'  borderRadius='10px'  boxShadow='0px 0px 10px black' padding='40px 20px'>
        <h3 className='mb-5 mx-auto' style={{ width: 'fit-content' }}>Welcome <strong className='text-light px-4 py-1' style={{ borderRadius: '10px', backgroundColor: '#7a7d52' }}>{localStorage.getItem('userName')}</strong></h3>
        <Box className='mx-2'>
          <h3 className='mb-2'>Current Month Summary</h3>
          <Table>
            <TableHead sx={{ bgcolor: "#7a7d52" }}>
              <TableRow>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Site name</TableCell>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Total Jobs</TableCell>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Allocated</TableCell>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Pending Approval</TableCell>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Orphan</TableCell>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Completed</TableCell>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Pending</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>ALDI</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.ALDI?.totalJobs}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.ALDI?.allocated}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.ALDI?.pendingApproval}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.ALDI?.orphan}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.ALDI?.completed}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.ALDI?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>Blooms</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.totalJobs}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.allocated}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.pendingApproval}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.orphan}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.completed}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>MM</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.totalJobs}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.allocated}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.pendingApproval}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.orphan}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.completed}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>Transport</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.totalJobs}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.allocated}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.pendingApproval}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.orphan}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.completed}</TableCell>
                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.pending}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
      
    </Box>
  );
};

export default AdminDashboard;
